<template>
  <div>
    <label v-for="(gender, code) of genders" :key="code" class="checkbox">
      <input type="checkbox" name="gender"  v-model="selected" :value="code">
      {{ gender }}
    </label>
  </div>
</template>

<script lang="ts">
import _ from 'lodash'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Genders, genderCode } from '@/store/common.types'

@Component
export default class GendersInput extends Vue {
  @Prop() value!: genderCode[]

  private genders = Genders

  private get selected(): genderCode[] {
    return this.value
  }

  private set selected(genders: genderCode[]) {
    this.$emit('input', genders)
  }
}
</script>

<style scoped>
input[type="checkbox"] {
  margin-right:8px;
}
.checkbox {
  margin-right:20px;
}
</style>
